export const FETCH_SURVEY_PAGE_BEGIN = 'survey/FETCH_SURVEY_PAGE_BEGIN';
export const FETCH_SURVEY_PAGE_SUCCESS = 'survey/FETCH_SURVEY_PAGE_SUCCESS';
export const FETCH_SURVEY_PAGE_ERROR = 'survey/FETCH_SURVEY_PAGE_ERROR';
export const SUBMIT_SURVEY_BEGIN = 'survey/SUBMIT_SURVEY_BEGIN';
export const SUBMIT_SURVEY_SUCCESS = 'survey/SUBMIT_SURVEY_SUCCESS';
export const SUBMIT_SURVEY_ERROR = 'survey/SUBMIT_SURVEY_ERROR';

export const CHANGE_CURRENT_SURVEY_PAGE_TO_VALUE = 'survey/CHANGE_CURRENT_SURVEY_PAGE_TO_VALUE';
export const HANDLE_QUESTION_RESPONSE_CHANGE = 'survey/HANDLE_QUESTION_RESPONSE_CHANGE';
export const CURRENT_PAGE_NOT_VALID = 'survey/CURRENT_PAGE_NOT_VALID';

export const ADD_ANSWER_IDS_TO_QUESTION_RESPONSE = 'survey/ADD_ANSWER_IDS_TO_QUESTION_RESPONSE';
export const REMOVE_ANSWER_IDS_TO_QUESTION_RESPONSE = 'survey/REMOVE_ANSWER_IDS_TO_QUESTION_RESPONSE';
